import React from "react";
import removeImg from "assets/svgs/close.svg";
import { v4 } from "uuid";
import { Col, Row } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import ImageUpdate from "./ImageUpdate";

const FeaturesArray = ({
  fields,
  append,
  remove,
  register,
  errors,
  update,
  name = "sliders",
}) => {
  return (
    <div className="form-group branches sliders">
      <h5>
        <FormattedMessage id={"sliders"} />
        <button
          type="button"
          className="btn btn-green"
          onClick={() => {
            append({});
          }}
        >
          <FormattedMessage id={"addSlider"} />
        </button>
      </h5>
      <Row style={{ rowGap: "10px" }}>
        {fields.map((item, index) => {
          return (
            <Col xl={12} lg={12} md={12} xs={12} key={index}>
              <div key={item?.id} className="add-multi-component">
                <button
                  type="button"
                  onClick={() => remove(index)}
                  className="removeImg"
                >
                  <img src={removeImg} alt="" />
                </button>
                <Row>
                  <input
                    type="hidden"
                    value={item?.id || v4()}
                    {...register(`${name}.${index}.id`)}
                  />

                  <Col lg={12} xs={12}>
                    <ImageUpdate
                      value={item?.image}
                      setValue={(value) =>
                        update(index, { ...item, image: value })
                      }
                    />
                  </Col>
                  <Col lg={6} xs={12}>
                    <div className="form-group">
                      <h5>
                        <FormattedMessage id={"title"} /> ({" "}
                        <FormattedMessage id={"arabic-language"} /> )
                      </h5>
                      <input
                        type="text"
                        className="form-control form-outline"
                        {...register(`${name}.${index}.title.ar`, {
                          required: true,
                        })}
                      />
                      <p className="error-hint">
                        {errors?.[name]?.[index]?.["title"]?.ar?.type ===
                          "required" && (
                          <FormattedMessage id={"requiredField"} />
                        )}
                      </p>
                    </div>
                  </Col>
                  <Col lg={6} xs={12}>
                    <div className="form-group">
                      <h5>
                        <FormattedMessage id={"title"} /> ({" "}
                        <FormattedMessage id={"english-language"} /> )
                      </h5>
                      <input
                        type="text"
                        className="form-control form-outline"
                        {...register(`${name}.${index}.title.en`, {
                          required: true,
                        })}
                      />
                      <p className="error-hint">
                        {errors?.[name]?.[index]?.["title"]?.en?.type ===
                          "required" && (
                          <FormattedMessage id={"requiredField"} />
                        )}
                      </p>
                    </div>
                  </Col>
                  <Col xxl={6} xs={12}>
                    <div className="form-group">
                      <h5>
                        <FormattedMessage id={"description"} /> ({" "}
                        <FormattedMessage id={"arabic-language"} /> )
                      </h5>
                      <textarea
                        type="text"
                        className="form-control form-outline"
                        {...register(`${name}.${index}.description.ar`, {
                          required: true,
                        })}
                      ></textarea>
                      <p className="error-hint">
                        {errors?.[name]?.[index]?.["description"]?.ar?.type ===
                          "required" && (
                          <FormattedMessage id={"requiredField"} />
                        )}
                      </p>
                    </div>
                  </Col>
                  <Col xxl={6} xs={12}>
                    <div className="form-group">
                      <h5>
                        <FormattedMessage id={"description"} /> ({" "}
                        <FormattedMessage id={"english-language"} /> )
                      </h5>
                      <textarea
                        type="text"
                        className="form-control form-outline"
                        {...register(`${name}.${index}.description.en`, {
                          required: true,
                        })}
                      ></textarea>
                      <p className="error-hint">
                        {errors?.[name]?.[index]?.["description"]?.en?.type ===
                          "required" && (
                          <FormattedMessage id={"requiredField"} />
                        )}
                      </p>
                    </div>
                  </Col>
                </Row>
              </div>
            </Col>
          );
        })}
      </Row>
    </div>
  );
};

export default FeaturesArray;
